import { render } from "./indexVendor.vue?vue&type=template&id=37646c74"
import script from "./indexVendor.vue?vue&type=script&lang=js"
export * from "./indexVendor.vue?vue&type=script&lang=js"

import "./indexVendor.vue?vue&type=style&index=0&id=37646c74&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__